// @module Ames.HomeStore.HomeStore
define('Ames.HomeStore.HomeStore.View'
	, [
		'ames_homestore_homestore.tpl'

		, 'Ames.HomeStore.HomeStore.SS2Model'

		, 'Backbone'
	]
	, function (
		ames_homestore_homestore_tpl

		, HomeStoreSS2Model

		, Backbone
	) {
		'use strict';

		// @class Ames.HomeStore.HomeStore.View @extends Backbone.View
		return Backbone.View.extend({

			template: ames_homestore_homestore_tpl

			, initialize: function (options) {

				/*  Uncomment to test backend communication with an example service
					(you'll need to deploy and activate the extension first)
				*/

				this.model = new HomeStoreSS2Model();
				var self = this;
				this.model.fetch().done(function (result) {
					self.homeStore = result.text;
					self.render();
				});
			}

			, events: {
			}

			, bindings: {
			}

			, childViews: {

			}

			//@method getContext @return Ames.HomeStore.HomeStore.View.Context
			, getContext: function getContext() {
				//@class Ames.HomeStore.HomeStore.View.Context
				this.message = this.message || 'Hello World!!'
				return {
					homeStore: this.homeStore
				};
			}
		});
	});
